import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#594684',
    },
  },
  typography: {
    fontFamily: ["'Poppins'", 'sans-serif'].join(', '),
    fontSize: 16,
    body1: {
      fontSize: '1rem',
    },
  },
  components: {
    MuiInputBase: {},
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        sx: {
          mt: 3,
          px: 0.25,
          py: 0.4,
          'label ': {
            mt: 0.2,
            transform: 'translate(2px, -8px) scale(1)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        sx: {
          px: 0.25,
          py: 0.4,
          backgroundColor: '#fff',
          '.MuiInputBase-inputMultiline': {
            p: 1,
          },
          'label + &': {
            mt: 2.2,
          },
        },
      },
      styleOverrides: {
        notchedOutline: {
          border: '1px solid #e2e2e2',
          'legend span': {
            display: 'none',
          },
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        sx: {
          '.MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
            py: 1.25,
            pb: 1.125,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        sx: {
          mt: 3,
          label: {
            color: '#444',
            transform: 'translate(2px, -8px) scale(1)',
          },
        },
        size: 'small',
        inputProps: {},
        InputLabelProps: {
          shrink: true,
        },
      },
      styleOverrides: {
        root: { borderRadius: '5px' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
        startIcon: {
          color: '#fff',
        },
        containedPrimary: {
          color: '#fff',
          borderRadius: '5px',
          '&:hover': {
            backgroundColor: '#67509B',
          },
          '&:active': {
            backgroundColor: '#3E305E',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          height: '3rem',
          minWidth: '12rem',
          alignItems: 'center',
          paddingLeft: '1rem',
          textDecoration: 'none',

          '&:hover': {
            backgroundColor: '#f1f1f1',
          },
          '&:active': {
            backgroundColor: '#e2e2e2',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
        },
      },
      defaultProps: {
        elevation: 4,
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontWeight: 500,
          height: '3rem',
          minWidth: '12rem',
          alignItems: 'center',
          paddingLeft: '1rem',
          textDecoration: 'none',
          backgroundColor: '#fff',

          '&:hover': {
            backgroundColor: '#f1f1f1',
          },
          '&:active': {
            backgroundColor: '#e2e2e2',
          },
        },
      },
    },
  },
});
